//cn.js
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  message: {
    'city_and_vendor':'开通城市及供应商权限',
    'vendor':'供应商',


    'DDV': 'DDV',
    'Wuhan':'武汉',
    '武汉':'武汉',
    'Nanjing':'南京',
    '南京':'南京',
    'Shenzhen':'深圳',
    '深圳':'深圳',
    'Chongqing':'重庆',
    '重庆':'重庆',
    'Chengdu':'成都',
    '成都':'成都',
    'Shanghai':'上海',
    '上海':'上海',
    'Hongkong':'香港',
    '香港':'香港',
    'Beijing':'北京',
    '北京':'北京',
    'Central':'巴士总部',
    '巴士总部':'巴士总部',
    'xinyun':'新云',
    'tiandi':'天迪',
    'baoyuan':'宝苑',
    'suote':'索特',

    'info':'信息',
    'confirm_operation':'是否执行操作？',
    'authority':'权限',
    'allowed_discount':'允许折扣',
    'report_to':'汇报对象',
    'BU':'业务部门',
    'role':'职位',
    'name':'用户名',
    'Remove':'删除',
    'Detail':'详情',
    'edit_user':'编辑用户',
    'unselected':'未选权限',
    'selected':'已激活权限',
    'UserMangement':'用户管理页',
    'Mobile_Notif':'手机版现已推出，快去体验吧！ ',
    'Index_Performance':'巴士指数表现: ',
    'Index_Distribution':'巴士指数分布:',
    'Index_Distribution_Chart':'巴士指数分布 Index Distribution',
    'Grade_Distribution':'线路级别分布:',
    'Grade_Distribution_Chart':'线路级别分布 Grade Distribution',
    'locate':'定位',
    'Give_it_a_price':'修改价格',
    'summary':'合计',
    'Top_125+':'极佳(125+)',
    'Avg+_125_100':'优秀(125-100)',
    'Avg-_100_75':'较好(100-75)',
    'Low_75-':'普通(75-)',
    'Please_Select':'请选择',
    'Select':'选择',
    'Cost':'套装总价',
    'Nbr_Of_Bus_Lines':'线路数',
    'Buses_bodies':'车辆数',
    'Package_Validity':'套装有效期',
    'all_packages':'全部套装',
    'Delete':'删除',
    'Publish':'发布',
    'View':'查看',
    'published_packages_only':'已发布套装',
    'unpublished_packages_only':'未发布套装',
    'expired_packages':'过期套装',
    'Save_Package':'保存套装',
    'Bulk':'批量修改',
    'From':'从',
    'to':'至',
    'description2':'详情',
    'Please_select_package_valid_period':'套装有效期',
    'Save_Changes':'保存',
    'adjust':'修改套装名称',
    'Package_Index_Distribution':'套装推荐指数分布',
    'Package_Grade_Distribution':'套装线路级别分布',
    'Package_History':'套装记录',
    'Package_Information': '套装信息',
    'Package_Name2':'套装名称',
    'Calculate':'计算',
    'Valited_Until':'套装有效期至',
    'Description':'详情',
    'Product_Cost_Discount':'制作费折扣',
    'Impression':'广告有效展示次数',
    'Ratecard_CPM':'基于刊例价 CPM',
    'Package_CPM':'套装 CPM',
    'Round_Up_Cost':'手动微调',
    'Total_Package_Cost':'套装总价',
    'Package_CPM_cluster':'套装 CPM\n(基于目标受众)',
    'Calculation':'计算套装价格',
    'Final_Package_Cost':'套装价格',
    'Bus_body(qty)':'车辆数',
    'Grading':'线路级别',
    'Bus':'线路名称',
    'Viewed_Impression(Audience)_row': '广告有效\n展示次数\n（目标受众）',
    'Bus_Line_Qty':'线路数',
    'Bus_Body_Qty':'车辆数',
    'Viewed_Impression_row':'广告有效\n展示次数',
    'Num_of_POI':'POI数量',
    'Create_Package':'创建套装',
    'platform_title':'巴士媒体受众测量系统',
    'Draft': '草稿',
    'Discussion': '谈判',
    'Sent': '提案',
    'Win': '成功签单',
    'Fail': '未成功签单',
    'Archive': '归档',
    'Notice': '提示',
    'Notice_dia':'所有线路的巴士台数都将改变，您确定吗？',
    'Notice_Content':'您确定要继续吗？',
    'Notice_Yes':'确 定',
    'Notice_Cancel':'取 消',
    'Select':'请选择',
    'POIType':'兴趣点类型',
    'POILocation':'兴趣点位置',
    'LegacyFixedSystem':'固定等级系统 - 可与其他选项联动来筛选巴士线路',
    'ByAudience':'受众',
    'ByPointsOfInterest':'兴趣点',
    'Select_Media_Format':'选择媒体形式',
    'CampaignByPerformanceCriterias':'选择你的排序标准',
    'RegularRateCard':'快选',
    'General': '通用',
    'Advanced': '高级',
    'Performance_Criterias':'排序标准',
    'Next_Step':'下一步',
    'Done':'完成',
    'Files':'文件',
    'Edit':'编辑',
    'Share':'分享',
    'Share_the_proposal':'分享提案',
    'Share_with':'分享给',
    'Please_select_the_users':'请选择用户',
    'Cancel':'取消',
    'Confirm':'确定',
    'Success':'成功',
    'Share_with_success':'分享成功',
    'Warning':'警告',
    'This_proposal_has_been_already_shared_with_user':'此提案已经与$user共享',
    'Error':'错误',
    'Fail_to_share':'分享失败',
    'Please_enter_the_client_name': '请输入客户名',
    'The_data_is_successfully_uploaded': '数据已成功上传!',
    'The_data_is_failed_to_upload': '数据上传失败!',
    'Total_population_covered': '所有覆盖人口',
    'With a potential audience of': '潜在受众数量',
    'T': '',
    'textCPM': 'CPM = 1000 * （媒体报价 / 广告有效展示次数）CPT=CPM:M来自于罗马数字“千”',
    'textViewedImpressions': '一种度量单位，包括有机会看到（又称为流量），通知和停留时间的总人数，该人数已根据媒体的有效长度进行了校准。也可以解释为通过数字户外显示或静态显示的人们很可能注意到一条消息的总次数。该概念有时称为“有效接触人次”或“ VAC”。',
    'textCoverageAudience':'单月覆盖人口（预测值）', 
    'textOneMonthFreq':'单月受众看到广告的平均次数', 
    'textCovergaePercentage':'城市人口中看到广告至少一次的人群比例', 
    'Select_this_city': '选择这座城市',
    'Select_cities': '选择城市',
    'Upload_inventory': '上传库存',
    'Choose_one_city': '选择城市',
    'Desperately_loading': '拼命地加载中...',
    'Error': '错误',
    'Login': '登录',
    'Hello': '您好',
    'Email': '邮箱',
    'Password': '密码',
    'rank':'等级',
    'Months':'月',
    'Training':'培训',
    'To_ensure_your_better_experience_please_use_chrome_browser':'为了得到更佳的体验，请选用Chrome浏览器',
    'Recommended_Bus_Lines_Text1':'Index = 根据上一页选择的标准，对最佳巴士线路进行推荐的指数。',
    'Recommended_Bus_Lines_Text2':'机制：平均值 = 100',
    'Recommended_Bus_Lines_Text3':'X线路的指数 = 123',
    'Recommended_Bus_Lines_Text4':'Y线路的指数 = 102',
    'Recommended_Bus_Lines_Text5':'Z线路的指数 = 78',
    'Recommended_Bus_Lines_Text6':'示例： X与平均值（100）相比，前2线路的表现正常',
    'Recommended_Bus_Lines_Text7':'示例： 最后一条与我们的选择的相关性差',
    'Recommended_Bus_Lines_Text8':'注意：多个条件会同时影响我们的选择：受众的特征，以及与POI的组合。',
    'Recommended_Bus_Lines_Text9':'示例： ',
    'Recommended_Bus_Lines_Text10':'-女性＆ 25-34',
    'Recommended_Bus_Lines_Text11':'或者',
    'Recommended_Bus_Lines_Text12':'-女性和25-34岁及购物中心',
    'Recommended_Bus_Lines_Text13':'将为同一条巴士线路提供不同的指数。因此，推荐指数是动态的，将根据您的选择而变化。',
    
    'Bus_Audience': '巴士媒体受众',
    'Measurement': '测量系统',
    'Estimated_Cost': '预计媒体成本',
    'Population': '城市人口数',
    'Audience': '受众特征',
    'audience': '人群画像',
    'audience_info': '受众特征信息',
    'campaign_info': '广告活动信息',
    'Nanjing': '南京',
    'Wuhan': '武汉',
    'Recommended_Bus_Lines_Text':'',
    'Please_select_a_city_to_explore_more': '请选择城市已浏览更多',
    'Kms_covered': '线路总公里数',
    'Bus_Lines': '巴士线路数量',
    'Population_of_': '人口 ',
    'Audience_of_': '受众',
    'Please_Contact_IT': '请联系IT',
    'Please_select_a_city_first': '请先选择一座城市',
    'Welcome': '欢迎',
    'Sign_Out': '注销',
    'History': '历史记录',
    'Statistics':'统计页',
    'City': '城市',
    'Date': '日期',
    'Audience information': '受众信息',
    'Selected_Recommended_Bus_Lines': '选择推荐的巴士线路',
    'Gross_CPM': '千次展示成本 ¥',
    'Gross_CPM_1': '千次展示成本',
    'Gender': '性别',
    'Age': '年龄',
    'Spend_Power': '消费能力',
    'Interests': '兴趣偏好',
    'BUSINESS': '商务',
    'Business_Center': '商务中心',
    'Industrial_Park': '工业园区',
    'Government': '政府',
    'ENTERTAINEMENT': '娱乐',
    'Sports': '体育场馆',
    'Entertainment': '娱乐休闲',
    'Culture': '文化影视',
    'LIVING': '生活',
    'Shopping': '购物',
    'Residental_Area': '居住区',
    'Food_Drinks': '餐饮',
    'School_University': '学校及高校',
    'Hospital': '医院',
    'TRIP': '旅游',
    'Tourist_Attractions': '热门景点',
    'Transportation_Hub': '交通枢纽',
    'Art_Museum': '艺术及博物馆',
    'Media_Format': '媒体形式',
    'Rank': '线路级别',
    'POI': '兴趣点',
    'Nearby_Location': '途经地点',
    'Info': '消息',
    'The_data_is_based_on_your_ranking': '该线路方案是基于线路级别推荐',
    'Legacy': 'Legacy',
    'Please_Contact_IT': '请联系IT',
    'Please_select_a_city_first': '请先选择一座城市',
    'Potential_Audience': '潜在受众',
    'Please_select_the_audience_profile_for_the_measurement_solution': '请选择受众信息以完成测量',
    'Please_select_the_POI_information_for_the_measurement_solution': '请选择POI信息以完成测量',
    'Please_select_the_bus_media_format_available_in_your_inventory': '请选择清单中可用的巴士媒体格式',
    'Please_select_the_bus_product_rank_in_your_inventory': '请选择清单中选择巴士产品等级',
    'Information': '信息汇总',
    'Graphic_Chart': '图例',
    'Commercial': '商业',
    'Modify_Information': '修改信息',

    'Total_Media_Cost': '媒体费',
    'CPM': '千次展示成本 ¥',
    'CPM_1': '千次展示成本',
    'CPM_Selection_Based': '千次展示成本\n（基于目标受众）',
    'CPM_Selection_Based_1': '千次展示成本(目标受众)',
    'CPM_Target_Audience_Based':'千次展示成本\n（基于目标受众）¥',
    'CPM_Target_Audience_Based_1':'千次展示成本(基于目标受众)',
    'CPM_Total_And_Selection':'千次展示成本(全部/受众)',
    'CPM_chart':'千次展示成本 CPM ¥',

    'Bus_Line': '巴士线路',
    'Related_Location_Number':'途经地点\n个数',
    'Media_Format': '媒体形式',
    'Media_Cost': '媒体刊例费\n/月/台 ¥',
    'Total_Media_Cost': '媒体刊例费总价 ¥',
    'Total_Media_Cost_1': '媒体刊例费总价',
    'Total_Media_Cost_2': '媒体刊例费总价 ¥',
    'Total_Media_Cost_RC': '媒体刊例费总价 ¥',
    'Production_Cost': '制作费',
    'Total_Production_Cost': '制作费',
    'Total_Production_Cost_RC': '制作刊例费总价 ¥',
    'Bus_Quantity': '巴士台数',
    'Gross_Price': '价格',
    'Reach': '触达',
    'Frequency': '频次',
    'Global': '全球',
    'Media_Cost_Discount':'媒体费折扣',

    'Number_of_Bus_Lines': '巴士线路数量',
    'Number_of_Lines_And_Bus': '线路数量 / 巴士数量',
    'Audience_Reach': '受众百分比',
    'Viewed_Impression': '广告有效展示次数',
    'Distinct_Audience': '单月有效接触人数',
    'One_Month_Freq': '单月有效接触频次',
    'Covergae_Percentage': '人口到达率',
    'Viewed_Impression_2': '\n广告有效展示次数',
    'Viewed_Impression_chart': '广告有效展示次数 Viewed impressions',
    'Viewed_Impression()': '广告有效展示次数',
    'Viewed_Impression_Selection_Based': '广告有效展示次数\n(受众)',
    'Viewed_Impression_Total_And_Selection': '有效展示次数(全部/受众)',
    'Commercial': '商业',
    'Campaign_Starting_Date': '活动开始日期',
    'Campaign_Starting_Date_1': '广告活动开始日期',
    'Duration': '发布时长',
    'Duration2': '发布平均时长\n(月)',
    'Duration3': '发布平均\n时长(月)',
    'Campaign_Starting_Date_And_Duration': '活动开始日期 / 发布时长',
    'Month': '月',
    'Estimated_Potential_Audience': '预计目标受众广告有效展示次数',
    'Viewed_impression_Upgraded_metric':'广告有效展示次数 = 更高级的度量标准',
    'Viewed_impression_reflects_the_number_of_people':'广告有效展示次数反映的是实际“固定”观看广告至少1秒钟（可以与在线点击率比较）的人数，这可以代替OTS',
    'This_methodology_includes_complex_viewability_factors_already_used_internationally_by_the_OOH_industry': '这种方法包括OOH行业已在国际上广泛使用的复杂可见性因素（距离，广告大小，车辆速度等），这是向市场解释的新概念。',
    
    'Sunday': '星期天',
    'Monday': '星期一',
    'Tuesday': '星期二',
    'Wednesday': '星期三',
    'Thursday': '星期四',
    'Friday': '星期五',
    'Saturday': '星期六',
    'Jan': '一月',
    'Feb': '二月',
    'Mar': '三月',
    'Apr': '四月',
    'May': '五月',
    'Jun': '六月',
    'Jul': '七月',
    'Aug': '八月',
    'Sep': '九月',
    'Oct': '十月',
    'Nov': '十一月',
    'Dec': '十二月',
    'No_Authority':'没有权限',
    'Recommended_Bus_Lines': '推荐的巴士线路',
    'Refresh': '刷新',
    'Back': '返回',
    'Next': '下一步',
    'Save_Data': '保存数据',
    'Line': '巴士线路',
    'index': '推荐\n指数',
    'index2': '推荐指数',
    'operation': '操作',
    'Bus_Body': '巴士台数',
    'Format': '形式',
    'Number_of_Bus_Body': '巴士台数',
    'Duration(Months)': '发布时长 (月)',
    'Viewed_Impression': '广告有效展示次数',
    'Viewed_Impression_Selection_Based': '广告有效展示次数\n基于选择',
    'Viewed_Impression(Audience)': '广告有效展示次数\n（基于目标受众）',
    'Viewed_Impression(Audience)_1': '广告有效展示次数(目标受众)',
    'Cancel': '取消',
    'Cancelled':'已取消',
    'Data_is_saved':'数据已保存',
    'OK': '好',
    'Do_you_want_to_save_data_you_made':'您想保存您已完成的数据吗？',
    'Please_select_file_type': '请选择文件类型',
    'Import':'导入',
    'Export':'导出',
    'Export_PDF':'导出 PDF',
    'Upload_logo':'上传商标',
    'Client_name':'客户名称',
    'File_Type':'文件类型',
    'Total_indicators':'全部指标',

    'Proposal_Status_Reminder': '提案状态提醒',
    'Proposal_Status_Reminder_number_old': 'F',
    'Proposal_Status_Reminder_number': '您有 {{number}} 条提案长时间未有进展，请及时更新状态！',
    'Got_it': '明白了',
    'Created_at':'创建时间',
    'Updated_at':'更新时间',
    'Package_name':'套装名称',
    'Validation_Start':'套装可销售起始日期',
    'Validation_End':'套装可销售截止日期',
    'Campaign_start':'广告活动开始',
    'Campaign_end':'广告活动结束',
    'Actions':'操作',
    'Created_by':'创建者',
    'Team':'部门',
    'Status':'状态',
    'Operation':'操作',
    'You_must_select_one_media_format':'您必须选择一个巴士媒体格式',
    'Quarterly_target_percentage_warning':'警告：季度百分比总和大于100',
    'Setting_sales_target': '设置销售目标',
    'Back_to_new_version': '回到新版本',
    'Back_to_old_version': '回到旧版本',
    'Setting':'设置',
    'Annual_target':'年目标值',
    'Q1_target':'Q1目标值',
    'Q2_target':'Q2目标值',
    'Q3_target':'Q3目标值',
    'Q4_target':'Q4目标值',
    'Can_crosscity':'多城市提案',

    'Average':'平均值：',

    'Overall_distribution_gender':'整体分布情况（性别）',
    'Detailed_distribution_gender':'线路详细分布情况（性别）',
    'Overall_distribution_age':'整体分布情况（年龄）',
    'Detailed_distribution_age':'线路详细分布情况（年龄）',
    'Overall_distribution_spend_power':'整体分布情况（消费能力）',
    'Detailed_distribution_spend_power':'线路详细分布情况（消费能力）',
    'Overall_distribution_interest':'整体分布情况（兴趣偏好）',
    'Detailed_distribution_interest':'线路详细分布情况（兴趣偏好）',

    'gender_female' : '女性',
    'gender_male' : '男性',
    'age_18_24' : '18-24',
    'age_25_34' : '25-34',
    'age_35_44' : '35-44',
    'age_45_54' : '45-54',
    'age_55_64' : '55-64+',
    'spend_power_low' : '低消费',
    'spend_power_medium' : '普通消费',
    'spend_power_high' : '高消费',
    'spend_power_low_income' : '低收入',
    'spend_power_middle_income' : '中等收入',
    'spend_power_middle_class' : '小康',
    'spend_power_upper_middle_class' : '中产',
    'spend_power_rich' : '富翁',
    'spend_power_super_rich' : '富豪',
    'interest_banking_finance' : '银行及金融',
    'interest_beauty_healthcare' : '美妆及洗护用品',
    'interest_cars_it' : '汽车及电子产品',
    'interest_lifestyle_catering' : '餐饮及本地生活服务',
    'interest_online_shopping_social_media' : '电子商务及社交媒体',
    'interest_online_training_education' : '在线培训及教育',
    'interest_video_entertainment' : '在线视频及娱乐',
    'interest_travel_tourism' : '旅游观光',

    'proposal_status':'订单状态     ',
    'process_status':'折扣申请状态',
    '7_days':'7 天',
    '30_days': '30 天',
    '90_days': '90 天',

    'calculate':'开始计算',
    'Number_of_lines':'线路数量',
    'Package_Name':'套装命名',
    'Please_select_package_valid_period':'套装有效期',
    'Validate_Until': '套装可销售时间',
    'Bulk':'批量修改',
    'Number_of_POIs':'途经站点车辆数',
    'Total_bus_line_QTY':'线路总数',
    'Total_bus_body_QTY':'车辆总数',

    'textProposalStatistics':'根据准备时间',
    'Select_Date':'选择日期',
    'textProposalTop':'针对提案状态订单',
    'Top_5_Valued_Proposal_Summary': '前五名最高价值订单',
    'Average_Proposal_Value':'平均订单价格',
    'Average_Viewed_Impressions':'平均订单有效展示次数',
    'Viewed_Impressions_Generated': '订单总计有效展示次数',
    'Proposals':'订单',
    'Top_50_popular_bus_lines':'前50名热门巴士线路',
    'Proposal_Value':'订单价格',
    'Viewed_Impressions':'有效展示次数',
    'Select_Range':'选择范围',
    'To':'至',

    'Upload_Inventory_Progress': '文件上传中，请稍后。',
    'Upload_Inventory_Success': '文件上传成功，系统会尽快更新库存。',
    'Upload_Inventory_Error_Network': '文件传输失败。',
    'Upload_Inventory_Error_Excel': '仅支持Excel文件，请检查。',
    'Upload_Inventory_Error_Col_Missing': 'Excel文件缺失内容，请检查。',

    'Bus_Body_Warning_Text': '{{line}}路 仅剩余 {{remaining}} 台，但您选取了 {{selected}} 台。',
    'Bus_Body_Remaining_Tooltip': '剩余 {{remaining}} 台',
    'Bus_Body_No_Inventory_Tooltip': '没有该线路的库存信息',
    'Upload_History': '库存记录',
    'Please_select_a_proposal': '请选择一个提案',
    'Proposal_selected': '已选择提案',
    'General' : '概览',

    'Search_client': '搜索客户: ',
    'Search_creator': '搜索创建者: ',
    'Please_enter_keyword': '请输入关键字',
    'Filter': '筛选',
    'Reset': '重置',
    'Filter_Confirm': '筛选',

    'Distribution_of_road_types': '城市道路类型分布', 
    'Distribution_of_road_types_Chart': '城市道路类型分布\nDistribution of Road Types', 
    'Proportion': '占比',
    '1W-2L-R': '单向双车道',
    '1W-3L-R': '单向三车道',
    '2W-2L-R': '双向双车道',
    '2W-4L-R': '双向四车道',
    '2W-6L-R': '双向六车道',
    '2W-8L-R': '双向八车道',
    'Highway': '高速公路',
    
    'Hourly_Pattern_Audience_Distribution': '全天平均展示次数分布',
    'Hourly_Pattern_Audience_Distribution_Chart': '全天平均展示次数分布\nHourly pattern: Daytime Viewed Imp Distribution',
    'Workday': '工作日',
    'Weekend': '周末',
  
    'Bus_network_length': '巴士线路长度',
    'Bus_stops': '巴士站点数',
    'Total_AOI': '城市AOI总量',
    'Total_POI': '城市POI总量',
    'Last_Year':'去年',
    'This_Year': '今年',
    'This_Month': '本月',
    'quarter_1':'第一季度',
    'quarter_2':'第二季度',
    'quarter_3':'第三季度',
    'quarter_4':'第四季度',
    'Total_Pipeline': '方案总金额',
    'Wins':'成功方案金额总计',
    'Trend':'签单趋势',
    'Avg_Cycle':'平均谈判周期',
    'Cycle':'周期趋势',
    'Achievement_vs_Target':'销售目标达成率',
    'name':'姓名',
    'Activity':'活动量',
    'Date':'日期',
    'Client':'客户',
    'Discount':'折扣',
    'Whole_Cycle':'周期',
    'Days':'天',
    'Input_Target':'请输入你的目标',
    'YOY_Trend':'同比增长',
    'Statistic_proposal':'有效方案',
    'Avg_Discount':'平均折扣',
    'Page_View':'访问量',
    'Table_Num_Proposal':'方案数（包含草稿)',

    'Media_Cost': '媒体费',
    'Production_Cost_1': '制作费',
    'Proposal_Cost': '折后总价',
    'Total_Cost': '总价',
    
    'Media_CPM': '媒体费 CPM',
    'Media_CPM_cluster': '媒体费 CPM\n（基于目标受众）',
    'Proposal_CPM': '折后总价 CPM',
    'Proposal_CPM_cluster': '折后总价 CPM\n（基于目标受众）',
    'Proposal_CPM_cluster_1': '折后总价 CPM(目标受众)',
    'Total_Proposal_CPM_1': '提案总体 CPM',
    'Total_Proposal_CPM_2': '折后总价 CPM\n（总体）',
    
    'Media_CPM_Total_And_Selection':'媒体费 CPM (全部/受众)',
    'Media_CPM_Total_And_Selection_1':'媒体费 CPM\n(全部/受众)',
    'Proposal_CPM_Total_And_Selection':'折后总价 CPM (全部/受众)',
    'Proposal_CPM_Total_And_Selection_1':'折后总价 CPM\n(全部/受众)',
    'Proposal_CPM_Selection_And_Total':'CPM (受众/全部)',
    'Rate_Card_Media_CPM_Total_And_Selection':'折扣前媒体费 CPM (全部/受众)',
    'Rate_Card_Media_CPM_Total_And_Selection_1':'折扣前媒体费 CPM\n(全部/受众)',
    'Rate_Card_Proposal_CPM_Total_And_Selection':'折扣前总价 CPM (全部/受众)',
    'Rate_Card_Proposal_CPM_Total_And_Selection_1':'折扣前总价 CPM\n(全部/受众)',

    'Pricing':'折扣',
    'Rate_Card_Price':'刊例价',
    'Rate_Card_Proposal_Cost':'折扣前总价',
    'Rate_Card_Proposal_CPM':'折扣前总价 CPM',
    'Rate_Card_Proposal_CPM_1':'折扣前总价 CPM',
    'Rate_Card_Media_Cost':'折扣前媒体费刊例价',
    'Rate_Card_Media_Cost_1':'折扣前媒体费刊例价',
    'Rate_Card_Media_CPM':'折扣前媒体费刊例价 CPM',
    'Rate_Card_Production_Cost':'制作费',
    'Rate_Card_Production_Cost_1':'制作费',
    'Reduced_Rate':'折扣比例',
    'Discounted_Price':'折后价',
    'Media_Discount': '媒体费折扣',
    'Proposal_Discount': '总价折扣',
    'Discount_Type': '折扣类型',

    'Total_Audience': '总体',
    'Target_Audience': '基于目标受众',

    'Media_Cost_RC_Discounted': '媒体费\n（折前价/折后价）',
    'Exporting': '导出中...',
    'Quiz_pub': '扫描/点击 左侧的二维码，来测试你的DOOH术语水平吧！',
    'Discount_Warning': '当前折扣需要部门主任批准',
    'Discount_Warning_External': '当前折扣过低，请联系管理员',
    'No_salesdirector_Warning': '折扣申请失败：未设置部门主任/销售总监',
    'Discount_Notice': '当前折扣过低，需要进入审批流程，通过部门主任批准。',
    'Client_Name_Notice': '请输入客户名称',
    'Proposal': '提案',
    'Appliance': '折扣申请',
    'Pending': '等待审批',
    'Approved_by_Director': '主管已通过',
    'Changed_by_Director': '主管已修改',
    'Refused_by_Director': '主管已拒绝',
    'Accepted': '已接受',
    'Refused': '已拒绝',
    'Review': '审阅',
    'Withdraw': '撤销',
    'Comment': '备注',
    'Refuse': '拒绝',
    'Accept': '接受',

    'Withdraw_Process_Notice': '你确定要撤销这份申请吗？',
    'Confirm_Process_Notice': '你确定要通过这份申请吗？',
    'Change_Process_Notice': '你确定要改变这份申请的价格吗？',

    'Operation_succeeded': '操作成功',
    'Operation_failed': '操作失败',
    'Update_Progress_Succeed': '申请更新成功，即将返回申请列表。',
    'Update_Progress_Fail': '申请更新失败，请联系DDV部门。',

    'Applied': '已申请',
    'Applicant': '申请人',
    'Sales_Director': '销售主管',
    'No_salesdirector_Warning': '折扣申请失败：未设置部门主任/销售总监',

    'Proposal_Cost_Exp': '折后总价包含：媒体费 + 制作费',
    'Media_Discount_Exp': '媒体费 x 折扣 + 制作费',
    'Proposal_Discount_Exp': '(媒体费 + 制作费) x 折扣 ',
    'Total_Cost_Exp': '包含：媒体费 + 制作费',
    'number_proposal':'订单数量',
    'avg_viewed_impression':'订单平均有效展示次数',
    'avg_price':'订单平均价格',
    'avg_bus_line':'平均线路数',
    'avg_bus_body':'平均巴士总数',
    
    'No_data':'暂无数据',

    'Auth_warning_message': '会话超时或其他认证错误，请重新登陆。',
    'Error_title': '抱歉遇到了服务器问题...',
    'Error_message_1': '您可以：',
    'Error_message_2': '1. 返回首页',
    'Error_message_3': '2. 联系我们',

    'Start_date': '开始日期',
    'End_date': '结束日期',
    'Message': '信息',
    'User_name': '用户名',
    'File_name': '文件名',
    'All': '全部',

    'Create': '添加',
    'Inventory_list': '库存列表',
    'Bus_line': '线路',
    'Ranking': '级别',
    'Plate': '牌照',
    'Bus_id': '自编号',
    'Bus_model': '巴士型号',
    'Status_start': '状态开始日期',
    'Status_end': '状态结束日期',
    'Reservation_start': '预订起始日期',
    'Reservation_end': '预订终止日期',
    'Contract_start': '合同起始日期',
    'Contract_end': '合同终止日期',
    'Production_start': '制作起始日期',
    'Production_end': '制作终止日期',
    
    'single_deck_2_panels': '单层双侧',
    'single_deck_3_panels': '单层三侧',
    'single_deck_half_bus_wrap': '单层半车身',
    'single_deck_full_bus_wrap': '单层全车身',
    'single_deck_full_bus_wrap_plus': '单层全车身Plus',
    'double_deck_full_bus_wrap': '双层全车身',

    'vehicle_status_0': '无异常',
    'vehicle_status_1': '维修保养',
    'vehicle_status_2': '报废',
    'vehicle_status_3': '运营控制',
    'vehicle_status_4': '优先销售',
    'vehicle_status_5': '其他',

    'add_bus_body': '添加车辆',
    'edit_bus_body': '编辑车辆',
    'Please_select_rank': '请选择巴士级别',
    'Please_select_status': '请选择巴士状态',
    'Status_date_range': '状态持续时间',
    'Reservation_date_range': '预订周期',
    'Contract_date_range': '合同周期',
    'Production_date_range': '制作周期',

    'Required_field': '必填项目',

    'bus_body_already_exists': '错误：巴士牌照已经存在。',
    'bus_body_create_failed': '错误：巴士添加失败。',
    'bus_body_create_successfully': '成功添加巴士。',
    'bus_body_not_exists': '错误：巴士牌照不存在。',
    'bus_body_edit_failed': '错误：巴士编辑失败。',
    'bus_body_edit_successfully': '成功编辑巴士。',
    'bus_body_delete_failed': '错误：巴士删除失败。',
    'bus_body_delete_successfully': '成功删除巴士。',
    'Bus_body_delete_notice': '此操作将永久删除该巴士：plate，是否继续？',

    'Search_bus_line': '搜索巴士线路',
    'Search_plate': '搜索巴士牌照',
    'Search_bus_id': '搜索巴士自编号',
    'number_proposal':'订单数量',
    'avg_viewed_impression':'订单平均有效展示次数',
    'avg_price':'订单平均价格',
    'avg_bus_line':'平均线路数',
    'avg_bus_body':'平均巴士总数',
    'Quiz_message': '点击来测试一下你对DOOH术语的了解吧！',

    'BU_Statistic':'销售所在BU',
    'City_Statistic':'媒体所在城市',
    'Bussiness_Statistic':'提案数据统计',
    'Activities_Statistic':'系统使用数据统计',
    'Search_by':'筛选条件',
    'Date_range':'时间范围',
    'Metrics':'指标',
    'Dimension':'维度',
    'Dimension_filter':'范围筛选',
    'Time_dimension':'时间维度',
    'Submit':'提交',
    'Export':'导出',
    'Activities':'活动数',
    'Sessions':'登录数',
    'UV':'独立访客数',
    'New_proposal':'新建提案数',
    'Active_proposal':'活跃提案数',
    'New Proposal':'新建提案数',
    'Active Proposal':'活跃提案数',
    'chart_title_by_time_yoy': '总{{metrics}}及同比趋势',
    'chart_title_by_bu':'各{{bu_dimension}}的{{metrics}}占比',
    'chart_title_by_bu_trend':'各{{bu_dimension}}的{{metrics}}趋势',
    'chart_title_bu_bu_stacked':'各{{bu_dimension}}的{{metrics}}堆积总数及趋势',
    'chart_title_by_user':'各用户{{metrics}}排名',
    'Year':'年',
    'Year-Month':'年-月',
    'Year-Week':'年-周',
    'Hour':'小时',
    'Definition_session':'登录次数，每次登录计为1次，不去重。',
    'Definition_activity':'包括登录，创建和更新提案在内的活动计数。',
    'Definition_UV':'独立访问次数: 1天内登录平台的1个用户数即计为1独立访问次数。',
    'Definition_New_proposal':'在选定日期范围内创建的所有提案的数量。',
    'Definition_Active_proposal':'在所选日期范围内创建的活提案的数量。活跃提案是指状态为“谈判”，“提案”，“成功签单”的提案。',
    'YOY':'同比',
    'remark_search':'*结果仅显示您业务部门（bu）内的数据',
    'no_data_statistic_v2':'在筛选条件下，没有关于{{metrics}}的数据',
    'last_year_kpi':'该指标在前一年的同期值为 : ',



    'add_user':'添加内部用户',
    'add_external_user':'添加外部用户',
    'company':'所属公司',
    'initial_password':'初始密码',
    'external':'外部',
    'internal':'内部',
    'disable_user':'停用',
    'enable_user':'启用',
    'new_password':'新密码',
    'confirm_new_password':'确认新密码',
    'activate':'激活账号',
    'account_has_been_activated':'该账号已经激活，请直接登录',
    'change_password':'修改密码',
    'pwd_cannot_be_null':'密码不能为空',
    'pwd_inconsistent':'两次密码输入不一致',
    'pwd_length_longer_than_12':'密码长度大于12个字符',
    'pwd_contains_character':'密码必须包含大写字母，小写字母，数字或特殊字符',
    'pwd_not_repeated':'用户不能重复使用其最近5个密码中的任何一个',
    'pwd_expired':'你的密码即将过期，请及时更新',


  },
  ...zhLocale
}

export default cn
